import React, { useEffect, useRef } from 'react';
import { Modal } from 'bootstrap';
import { Node } from '../model/Node';

const ReassignLicenseModal = ({ show, node, previousNode, onConfirm, onCancel }: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    modalRef.current && new Modal(modalRef.current, { backdrop: 'static' });
  }, []);

  useEffect(() => {
    if (modalRef.current) {
      const instance = Modal.getInstance(modalRef.current);
      if(instance) {
        show ? instance.show() : instance.hide();
      }
    }
  }, [ show ]);

  return (
    <div ref={modalRef} className="modal fade" data-bs-backdrop="static" tabIndex={-1}>
      <div className="modal-dialog modal-sm">
        <div className="modal-content bg-white">
          <div className="modal-header">
            <h5 className="modal-title w-100 text-center">Reassign license?</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            <p className="d-block text-center text-dark">
              The license <strong>{previousNode.licenseShortId}</strong> is currently assigned to <strong>{previousNode.name}</strong> - {previousNode.shortId}.
            </p>
            <p className="d-block text-center text-dark">
              Reassigning it will deactivate the current node and assign the license to <strong>{node.name}</strong> - {node.shortId}.
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary w-100" data-bs-dismiss="modal" onClick={onConfirm}>Reassign</button>
            <button type="button" className="btn bg-gray-02 w-100" data-bs-dismiss="modal" onClick={onCancel}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

interface Props {
  show: boolean,
  node: Node,
  previousNode: Node,
  onConfirm: () => void;
  onCancel: () => void;
}

export { ReassignLicenseModal };
